import { Pipe, PipeTransform } from '@angular/core';
import { ResponseTemplate } from '../common-review-card/review-types';

@Pipe({
  name: 'paginateTemplates',
  standalone: false,
})
export class PaginateTemplatesPipe implements PipeTransform {
  static paginateTemplates(responseTemplates: ResponseTemplate[], page: number): ResponseTemplate[] {
    const start = (page * 3) % responseTemplates.length;
    const end = start + 3;
    const templates = responseTemplates.slice(start, end);
    if (end > responseTemplates.length && responseTemplates.length > 3) {
      templates.push(...responseTemplates.slice(0, end - responseTemplates.length));
    }
    return templates;
  }

  transform(responseTemplates: ResponseTemplate[], page: number): ResponseTemplate[] {
    if (!responseTemplates) {
      return [];
    }
    return PaginateTemplatesPipe.paginateTemplates(responseTemplates, page);
  }
}
